module.exports = __webpack_public_path__ + "img/large.47a0cab8.png";